module.exports = __webpack_public_path__ + "static/media/03.35778663.jpg";